import React, { Fragment, useState, useEffect } from 'react';
import Breadcrumb from '../common/breadcrumb';
import Tablereact from '../common/tabulator/tablereact'
import Loader from '../common/loaderapp';
import {useHistory} from 'react-router-dom';

const Articulos = () => {
    const history = useHistory();
    const [load, setLoad] = useState(false);
    const [datos, setDatos] = useState([]);

    useEffect(() => {
        fetch('/p_noticias', {headers: {'Content-Type': 'application/json'}})
        .then(res => res.json())
        .then(res => {
     /*        console.log(res); */
            res[0].map((e,i)=>{
                res[0][i].FECHA=new Date(e.FECHA).toLocaleDateString();
                res[0][i].ESTATUS=e.ESTATUS?'Público':'Oculto';
            })
            setDatos(res[0])
            setLoad(true)
        })
        .catch(err => console.log('Error:',err))
    }, []);

    const cabecera = [
        { Header: <b>ID</b>, accessor: 'ID', style: { textAlign: 'center'}, width:'80', show:false },
        { Header: <b>Titulo</b>, accessor: 'TITULO', style: { textAlign: 'center'}, width:'400', editable:true , show:true},
        { Header: <b>Categoría</b>, accessor: 'CATEGORIA', style: { textAlign: 'center'}, width:'auto', editable:true , show:true},
        { Header: <b>Estatus</b>, accessor: 'ESTATUS', style: { textAlign: 'center'}, width:'110', editable:true , show:true},
        { Header: <b>FECHA</b>, accessor: 'FECHA', style: { textAlign: 'center'}, width:'auto', editable:true , show:true},
        // { Header: <b>Estatus</b>, accessor: 'ESTATUS', style: { textAlign: 'center'}, width:'auto', editable:true , show:true}
    ];

    const agregar=()=>history.push('/nuevo/publicacion');
    const detalle_dato=(dato)=>history.push('/editar/publicacion/'+dato.ID);
    
    return (
        <Fragment>
            <Breadcrumb parent="Publicaciones" title="Artículos" />
            {
                load ?
                    <div className="container-fluid">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body datatable-react">
                                    <Tablereact
                                        myData={datos}
                                        cabecera={cabecera}
                                        pageSize={20}
                                        paginacion={true}
                                        buscador='Buscar Artículo'
                                        detalle={detalle_dato}
                                        boton={{text:'Agregar Artículo',function:agregar}}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                :
                <Loader/>
            }
        </Fragment>
    );
};

export default Articulos;